import ExternalAnchorContainer from './external-anchor-container';

export default ExternalAnchorContainer;
